import {CompanyEntryDto} from '../dtos/CompanyEntryDto';
import {LocationDto} from "../dtos/LocationDto";


export class CompanyListWidgetRenderer {

    public constructor(private container: HTMLElement, private msg: string) {
    }

    public renderJobGiverItem(item: CompanyEntryDto) {
        var entryHtml = document.createElement("div");
        entryHtml.classList.add("_jobEntry");

        var entryDetailsWrapper = document.createElement("a");
        entryDetailsWrapper.classList.add('_jobEntryDetails');
        entryDetailsWrapper.setAttribute("href", "/u/" + item.permaLink + "/");
        entryDetailsWrapper.setAttribute("target", "_blank");


        var entryTitle = document.createElement("div");
        entryTitle.classList.add('_jobEntryTitle')
        var entryTitle_h3 = document.createElement("h3");
        entryTitle_h3.innerHTML = item.displayName;
        entryTitle.appendChild(entryTitle_h3);
        entryDetailsWrapper.appendChild(entryTitle);

        var companyImage = document.createElement("div");
        companyImage.classList.add('_jobGiverImage');
        companyImage.style.backgroundImage = "url(data:image/png;base64," + item.image + ")";
        entryHtml.appendChild(companyImage);

        var companyAddress = document.createElement("div");
        companyAddress.classList.add("_jobAdress");

        companyAddress.innerHTML = LocationDto.getAddressString(item.location);
        entryDetailsWrapper.appendChild(companyAddress);

        if (item.jobCount > 0) {
            var numberJobs = document.createElement("div");
            numberJobs.classList.add("_numberJobs");
            numberJobs.innerHTML = item.jobCount + " Job";
            if (item.jobCount > 1) {
                numberJobs.innerHTML = numberJobs.innerHTML + "s";
            }
            entryDetailsWrapper.appendChild(numberJobs);
        }

        entryHtml.appendChild(entryDetailsWrapper);
        this.container.appendChild(entryHtml);
    }

    public renderError() {
        var entryHtml = document.createElement("div");
        var errorHtml = document.createElement("div");
        errorHtml.innerHTML = this.msg;
        errorHtml.classList.add('_entryErrorText')
        entryHtml.appendChild(errorHtml);
        this.container.appendChild(entryHtml);
    }


}